module.exports = __webpack_public_path__ + "static/media/scheldure_moli.f56bd642.jpg";